import { toast } from 'react-toastify';
import appApi from '../../../../../../api/app-api';
import { displayErrorText } from '../../../../../../api/errors/api-error-codes';

export interface AddExternalExamRegistrationRequest {
  userId: number;
  branchId: number;
  programId: number;
  paymentExempted?: boolean;
}

export const addExternalExamRegistrationsOperation = async (
  groupId: number,
  examId: number,
  registrations: AddExternalExamRegistrationRequest[],
  setLoading: (isLoading: boolean) => void,
  onSuccess: () => void,
) => {
  try {
    if (registrations.length === 0) {
      toast.warn('יש לבחור לפחות סטודנט אחד');
      return;
    }

    setLoading(true);
    const res = await appApi.addExternalExamRegistrations(groupId, examId, {
      registrations: registrations,
    });

    if (res.data.ok) {
      toast.success(
        `הוספת זכאות להרשמה ל-${registrations.length} סטודנטים בוצעה בהצלחה`,
      );
      onSuccess();
    } else if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
    } else {
      toast.error('הוספת זכאות להרשמה נכשלה, נסה שוב בעוד מספר רגעים...');
    }
    setLoading(false);
  } catch (e) {
    toast.error('הוספת זכאות להרשמה נכשלה, נסה שוב בעוד מספר רגעים...');
    console.error(
      `addExternalExamRegistrationsOperation failed for groupId: ${groupId}, examId: ${examId} with error: ${e}`,
    );
    setLoading(false);
  }
};
